package dk.smark.demo.ui

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.zIndex
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import demo.composeapp.generated.resources.Res
import demo.composeapp.generated.resources.compose_multiplatform
import dk.smark.demo.Greeting
import dk.smark.demo.MainViewModel
import dk.smark.demo.location.GenericLocation
import dk.smark.demo.location.LocationResult
import dk.smark.demo.location.createLocationService
import dk.smark.demo.location.createShareService
import dk.smark.demo.map.MapController
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
fun HomeScreen(
    viewModel: MainViewModel = MainViewModel(),
    mapComponent: @Composable (location: GenericLocation) -> Unit,
    onUserLocationFound: (lat: Double, lon: Double) -> Unit,
    onTrackAvailable: (track: List<GenericLocation>) -> Unit,
    bannerAd: @Composable () -> Unit) {

    val shareService = remember { createShareService() }

    val isAdFree by viewModel.isAdFree.collectAsStateWithLifecycle(initialValue = null)

    val location by viewModel.lastKnownLocation.collectAsState(initial = null)

    val track by viewModel.locationTrack.collectAsState()

    var hasLocationPermission by remember {
        mutableStateOf(
            true
        )
    }

    LaunchedEffect(Unit) {
        viewModel.fetchLocation()
        viewModel.startTracking()
    }

    Box(modifier = Modifier.fillMaxSize()) {
        Column(modifier = Modifier.fillMaxSize()) {
            Box(modifier = Modifier.weight(1f)) {
                if (hasLocationPermission) {
                    if (location != null) {
                        mapComponent(location!!)
                    } else {
                        Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                            CircularProgressIndicator()
                        }
                    }
                } else {
//                PermissionDeniedContent(
//                    onRequestPermission = {
//                        launcher.launch(locationPermissions)
//                    }
//                )
                }
            }
            // CenterOnUserButton(getLocation = locationService::getCurrentLocation, onLocationFound = onUserLocationFound, onError = {})
            if (shareService.isSupported()) {
                Button(modifier = Modifier.align(alignment = Alignment.CenterHorizontally), onClick = {
                    viewModel.shareLocation()
                }) {
                    Text(text = "Share My Location")
                }
            }
        }

        if (location != null) {
            onUserLocationFound(location!!.latitude, location!!.longitude)
        }

        LaunchedEffect(track) {
            if (track.isNotEmpty()) {
                onTrackAvailable(track)
            }
        }
    }
}

@Composable
fun CenterOnUserButton(
    getLocation: suspend () -> LocationResult,
    onLocationFound: (Double, Double) -> Unit,
    onError: (String) -> Unit,
) {
    val scope = rememberCoroutineScope()

    Button(
        onClick = {
            scope.launch {
                when (val result = getLocation()) {
                    is LocationResult.Success -> {
                        onLocationFound(
                            result.location.latitude,
                            result.location.longitude
                        )
                    }
                    is LocationResult.Error -> {
                        onError(result.reason.toString())
                    }
                }
            }
        }
    ) {
        Text("Use my location")
    }
}

